<template>
  <div>
    <Loading v-if="loading && mode === 'edit'" />
    <form @submit.prevent="handleSubmit()" v-else>
      <label class="form-label">On These Days</label>
      <div class="grid grid-flow-col grid-cols-7 text-sm text-center border border-gray-300 divide-x divide-gray-300 rounded">
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 rounded-l hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.monday">
          Mon
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.tuesday">
          Tue
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.wednesday">
          Wed
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.thursday">
          Thu
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.friday">
          Fri
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.saturday">
          Sat
        </label>
        <label class="flex flex-col items-center justify-center p-3 leading-none text-gray-500 rounded-r hover:bg-gray-100">
          <input type="checkbox" class="mb-2 form-checkbox" v-model="form.sunday">
          Sun
        </label>
      </div>
      <div class="grid grid-cols-2 mt-4 space-x-4">
        <fieldset class="form-group">
          <label class="form-label">From</label>
          <div class="flex">
            <input type="text" class="form-input" v-model="form.start_time" v-cleave="{ time: true, timePattern: ['h', 'm'], timeFormat: '24' }">
          </div>
        </fieldset>
        <fieldset class="form-group">
          <label class="form-label">To</label>
          <div class="flex">
            <input type="text" class="form-input" v-model="form.end_time" v-cleave="{ time: true, timePattern: ['h', 'm'], timeFormat: '24' }">
          </div>
        </fieldset>
      </div>
      <div class="flex justify-between">
        <button type="submit" class="btn btn-primary" v-submitting="submitting" :disabled="noDaysSelected">
          {{ mode === 'create' ? 'Create Schedule' : 'Save Changes' }}
        </button>
        <button type="button" class="font-medium text-red-500 hover:underline" @click="deleteSchedule()" v-submitting="submitting" v-if="mode === 'edit'">
          Delete Schedule
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ScheduleForm',

  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },

  async created () {
    if (this.mode === 'edit') {
      this.loading = true
      await this.getSchedule()
    }
  },

  computed: {
    noDaysSelected () {
      return (!this.form.monday && !this.form.tuesday && !this.form.wednesday && !this.form.thursday && !this.form.friday && !this.form.saturday && !this.form.sunday)
    }
  },

  data () {
    return {
      loading: false,
      submitting: false,
      form: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        start_time: '09:00',
        end_time: '17:00'
      }
    }
  },

  methods: {
    handleSubmit () {
      if (this.mode === 'create') {
        this.createSchedule()
      } else {
        this.saveSchedule()
      }
    },
    
    async createSchedule () {
      try {
        this.submitting = true
        await this.$api.post(`account/${this.$route.params.account}/schedules`, this.form)
        await this.$store.dispatch('syncUser', this)
        this.$emit('success')
        this.submitting = false
      } catch (error) {
        console.error(error)
        this.submitting = false
      }
    },

    async getSchedule () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/schedules/${this.$route.params.id}`)
        this.form = data.schedule
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    async saveSchedule () {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/schedules/${this.$route.params.id}`, this.form)
        this.$store.dispatch('syncUser', this)
        this.$emit('success')
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    },

    async deleteSchedule () {
      if (window.confirm('Are you sure you want to delete this schedule?')) {
        try {
          this.submitting = true
          await this.$api.delete(`account/${this.$route.params.account}/schedules/${this.$route.params.id}`)
          this.$store.dispatch('syncUser', this)
          this.$emit('success')
        } catch (error) {
          console.error(error)
        } finally {
          this.submitting = false
        }
      }
    }
  }
}
</script>